





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';
import AlarmSelect from './alarm-select.vue';

@Component({components: {AlarmSelect}})
export default class AlarmTool extends Vue {
  @Mutation('SET_EVENTS') private SET_EVENTS: any;
  @Action('rocketAlarm/GET_ALARM') private GET_ALARM: any;
  @Prop() private durationTime: any;
  @Prop() private total!: number;
  private pageNum: number = 1;
  @Prop({type: Object, default: () => ({label: 'All', key: ''})})
  private alarmScope: any;
  @Prop({default: false, type: Boolean})
  private inTopo!: boolean;
  private alarmOptions: any = [
    {label: 'All', key: ''},
    {label: 'Service', key: 'Service'},
    {label: 'ServiceInstance', key: 'ServiceInstance'},
    {label: 'Endpoint', key: 'Endpoint'},
  ];

  private keyword: string = '';

  @Prop()
  private propKeyword!: string;

  private created() {
    if (this.propKeyword) {
      this.keyword = this.propKeyword;
    }
  }

  private handlePage(pageNum: number) {
    this.handleRefresh(pageNum);
  }

  private handleFilter(i: any) {
    this.alarmScope = i;
    this.handleRefresh(1);
  }

  private handleRefresh(pageNum: number) {
    this.pageNum = pageNum;
    const params: any = {
      duration: this.durationTime,
      paging: {
        pageNum,
        pageSize: 20,
        needTotal: true,
      },
    };
    if (this.alarmScope.key) {
      params.scope = this.alarmScope.key;
    }
    if (this.keyword) {
      params.keyword = this.keyword;
    }
    this.GET_ALARM(params);
  }

  private beforeMount() {
    this.SET_EVENTS([() => {
      this.handleRefresh(1);
    }]);
    this.handleRefresh(1);
  }

  private beforeDestroy() {
    this.SET_EVENTS([]);
  }

}
